export default __webpack_public_path__ + "assets/icons/info_solid.24b9e570.svg";